// src/components/CartIcon.js
import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import { useCart } from "../../context/cartContext"; // Import useCart hook

function CartIcon() {
    const { cartCount } = useCart(); // Get cart from context
    const navigate = useNavigate(); // Initialize navigation

    const handleClick = () => {
        navigate("/cart"); // Navigate to the Cart Page
    };
    return (
        <IconButton aria-label="cart" size="large" onClick={handleClick}>
            <Badge badgeContent={cartCount || 0} color="primary" showZero>
                <ShoppingCartOutlinedIcon />
            </Badge>
        </IconButton>
    );
}

export default CartIcon;
